import type { InterventionTemplatesListTableRowActionsProps } from "./intervention-templates-list-table-row-actions.type";

import ListTableRowActions from "@/modules/list-table-row-actions";

import InterventionTemplatesListTableRowActions from "./intervention-templates-list-table-row-actions.component";

const InterventionTemplatesListTableRowActionsWrapper = (
  props: InterventionTemplatesListTableRowActionsProps
) => {
  return (
    <ListTableRowActions>
      <InterventionTemplatesListTableRowActions {...props} />
    </ListTableRowActions>
  );
};

export default InterventionTemplatesListTableRowActionsWrapper;
